import { ARVORE_ROOT_PATH } from 'config/vars'
import { getCookie } from 'utils/cookies'
import type {
  RedemptionErrorCode,
  RedemptionResult
} from './OrderCodeForm.types'

export const REDEMPTIONS_URL = '/api-arvore/bookfair/redemptions'

const KNOWN_ERROR_CODES: RedemptionErrorCode[] = [
  'order_not_found',
  'order_used_up',
  'order_other_school',
  'student_not_in_school',
  'order_without_school',
  'order_name_mismatch'
]

export class RedemptionError extends Error {
  code: RedemptionErrorCode

  constructor(code: RedemptionErrorCode) {
    super(code)
    this.code = code
  }
}

export const normalizeOrderCode = (code: string): string =>
  code.trim().toUpperCase()

const readErrorCode = async (
  response: Response
): Promise<RedemptionErrorCode> => {
  if (response.status === 429) return 'too_many_attempts'

  try {
    const body = await response.json()
    return KNOWN_ERROR_CODES.includes(body?.code)
      ? body.code
      : 'unexpected_error'
  } catch {
    return 'unexpected_error'
  }
}

export const redeemOrderCode = async (
  code: string
): Promise<RedemptionResult> => {
  const accessToken = getCookie('access_token')
  const apiPath = process.env.FRONT_END_API_ARVORE_LOCAL ? '' : ARVORE_ROOT_PATH

  let response: Response

  try {
    response = await fetch(`${apiPath}${REDEMPTIONS_URL}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
      },
      body: JSON.stringify({ code: normalizeOrderCode(code) })
    })
  } catch {
    throw new RedemptionError('unexpected_error')
  }

  if (!response.ok) {
    throw new RedemptionError(await readErrorCode(response))
  }

  return response.json()
}
